export default "__VITE_ASSET__BGStBGrU__"